<script lang="ts">
    import Btn from "../../components/Btn.svelte";
    import ButtonRow from "../../components/ButtonRow.svelte";
    import Container from "../../components/Container.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Image from "../../components/Image.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import Row from "../../components/Row.svelte";
    import Subline from "../../components/Subline.svelte";
    import { t } from "../../helpers/translation";
</script>

<!-- <LightTheme /> -->
<!-- <Hero headline="zuverlässig und <br>schnell" small /> -->
<Hero small />

<Container>
    <!-- <center> -->
    <Headline>
        {@html $t("page.environment.headline")}
    </Headline>
    <Subline>
        {@html $t("page.environment.subline")}
    </Subline>

    <p>
        {@html $t("page.environment.p")}
    </p>

    <ButtonRow>
        <Btn yellow arrow href="ueber-uns/unsere-werte">
            {@html $t("page.environment.btn.about")}
        </Btn>
        <Btn arrow href="aktuelles/news">
            {@html $t("page.environment.btn.news")}
        </Btn>
    </ButtonRow>
</Container>

<style lang="scss">
    @import "../../vars";
</style>
